import styled from 'styled-components';

/**
 * Pílula de aviso de fatura no card da UC: "Fatura em aberto" (hasDebt, vermelho)
 * ou "Vence em Nd" (janela de D-3, âmbar). Regras em `utils/invoiceAlert`.
 * Cores espelham as pílulas de auditoria (âmbar = atenção; vermelho = ação).
 */
export const Pill = styled.span<{ $kind: 'open' | 'due' }>`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  margin-top: 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  padding: 3px 9px;
  border-radius: 3px;
  white-space: nowrap;
  ${(props) =>
    props.$kind === 'open'
      ? `color:#f42121;background:#fef1f1;border:1px solid #f42121;`
      : `color:#333333;background:#fef4e9;border:1px solid #f79422;`}
`;
